/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderMinusIcon16Light = forwardRef('FolderMinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5 9a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 2A1.5 1.5 0 0 0 1 3.5v8A2.5 2.5 0 0 0 3.5 14h8a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 11.5 4H8a.5.5 0 0 1-.4-.2l-.9-1.2A1.5 1.5 0 0 0 5.5 2h-3ZM2 3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .4.2l.9 1.2A1.5 1.5 0 0 0 8 5h3.5A1.5 1.5 0 0 1 13 6.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 2 11.5v-8Z" })));
});
